import {
  APIQueryResult,
  useAPIQuery,
  UseAPIQueryOptions,
} from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import {
  CarrierPerformanceDTO,
  carrierPerformanceSchema,
} from './CarrierPerformanceDTO';

export function useCarrierPerformanceIndicators(
  options?: UseAPIQueryOptions<CarrierPerformanceDTO>,
): APIQueryResult<CarrierPerformanceDTO> {
  return useAPIQuery(
    ['carrier', 'performance'],
    () => requestCarrierAPI('GET /internal/web/carrier/performance/'),
    { ...options, schema: carrierPerformanceSchema },
  );
}
